// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2vDz1","auth_block":"styles_auth_block__1r-ZV","logo_vdcloud":"styles_logo_vdcloud__BNf-b","logo_name":"styles_logo_name__371qX"};